import { render, staticRenderFns } from "./NewPage.vue?vue&type=template&id=3e056283&scoped=true&"
import script from "./NewPage.vue?vue&type=script&lang=js&"
export * from "./NewPage.vue?vue&type=script&lang=js&"
import style0 from "./NewPage.vue?vue&type=style&index=0&id=3e056283&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e056283",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e056283')) {
      api.createRecord('3e056283', component.options)
    } else {
      api.reload('3e056283', component.options)
    }
    module.hot.accept("./NewPage.vue?vue&type=template&id=3e056283&scoped=true&", function () {
      api.rerender('3e056283', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/v2/schema/NewPage.vue"
export default component.exports